import {BenchlingAction} from 'redux-stores/Action';

import {StructuredTableTogglableStateActionType} from './StructuredTableTogglableStateActions';

/**
 * Reducer for tracking the toggled edit state of some structured tables
 */

export enum StructuredTableEditStatus {
  LOCKED = 'LOCKED',
  EDITING = 'EDITING',
  // These two states are transient
  REVERTING = 'REVERTING',
  SAVING = 'SAVING',
}

export interface StructuredTableTogglableEditState {
  [tableId: string]: StructuredTableEditStatus;
}

function setStructuredTableEditStatus(
  state: {[id: string]: StructuredTableEditStatus},
  id: string,
  editStatus: StructuredTableEditStatus
): {[id: string]: StructuredTableEditStatus} {
  return {
    ...state,
    [id]: editStatus,
  };
}

export default function reduceStructuredTableEditState(
  state: StructuredTableTogglableEditState = {},
  action: BenchlingAction
): StructuredTableTogglableEditState {
  switch (action.type) {
    case StructuredTableTogglableStateActionType.STRUCTURED_TABLE_TOGGLABLE_EDIT_STATE_SET: {
      return setStructuredTableEditStatus(state, action.tableCid, action.editStatus);
    }

    default:
      return state;
  }
}
